/**
 * Header Search
 */
document.addEventListener('DOMContentLoaded', () => {
    const searchContainers = document.querySelectorAll('.header__search, .header__search-mobile');
    const mobileToggle = document.querySelector('.js-mobile-search-toggle');

    // Debounce helper
    const debounce = (func, wait) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    };

    const setButtonLoading = (button, loading) => {
        if (!button) return;
        button.classList.toggle('is-loading', loading);
    };

    // AJAX search
    const performSearch = async (query, resultsContainer, searchButton) => {
        resultsContainer.classList.add('is-loading');
        setButtonLoading(searchButton, true);

        const formData = new FormData();
        formData.append('action', 'search_site');
        formData.append('query', query);
        formData.append('nonce', params.nonce);
        formData.append('lang', params.current_lang);

        try {
            const response = await fetch(params.ajax_url, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            resultsContainer.classList.remove('is-loading');
            setButtonLoading(searchButton, false);

            if (data.success) {
                resultsContainer.innerHTML = data.data.html;
                resultsContainer.classList.add('is-active');
            } else {
                resultsContainer.innerHTML = `<div class="search-results__empty">${data.data.message || 'Error'}</div>`;
                resultsContainer.classList.add('is-active');
            }
        } catch (error) {
            resultsContainer.classList.remove('is-loading');
            setButtonLoading(searchButton, false);
        }
    };

    const initSearch = (container) => {
        const input = container.querySelector('input[type="search"]');
        const searchButton = container.querySelector('.header__search-btn, .js-mobile-search-toggle');
        if (!input) return;
        let resultsContainer = container.querySelector('.header__search-results');

        if (!resultsContainer) {
            resultsContainer = document.createElement('div');
            resultsContainer.classList.add('header__search-results');

            const mobileDropdown = container.querySelector('.header__search-mobile-dropdown');
            if (mobileDropdown) {
                mobileDropdown.appendChild(resultsContainer);
            } else {
                container.appendChild(resultsContainer);
            }
        }

        // Debounced input
        const handleInput = debounce((e) => {
            const query = e.target.value.trim();

            if (query.length < 3) {
                resultsContainer.innerHTML = '';
                resultsContainer.classList.remove('is-active');
                setButtonLoading(searchButton, false);
                return;
            }

            performSearch(query, resultsContainer, searchButton);
        }, 300);

        input.addEventListener('input', handleInput);

        // Show results on focus if already loaded
        input.addEventListener('focus', () => {
            if (resultsContainer.innerHTML.trim() !== '') {
                resultsContainer.classList.add('is-active');
            }
        });
    };

    // Close on outside click
    document.addEventListener('click', (e) => {
        const insideSearch = e.target.closest('.header__search, .header__search-mobile');
        if (!insideSearch) {
            document.querySelectorAll('.header__search-results').forEach(el => el.classList.remove('is-active'));
        }

        const insideMobileSearch = e.target.closest('.header__search-mobile');
        if (!insideMobileSearch) {
            const mobileDropdown = document.querySelector('.header__search-mobile-dropdown');
            if (mobileDropdown) mobileDropdown.classList.remove('is-open');
        }
    });

    // Mobile toggle - disabled in favor of popup
    if (mobileToggle && !mobileToggle.classList.contains('js-mobile-search-popup-toggle')) {
        mobileToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const container = mobileToggle.closest('.header__search-mobile');
            const dropdown = container.querySelector('.header__search-mobile-dropdown');

            dropdown.classList.toggle('is-open');

            if (dropdown.classList.contains('is-open')) {
                const input = dropdown.querySelector('input');
                if (input) setTimeout(() => input.focus(), 50);
            }
        });
    }

    // Init instances
    searchContainers.forEach(initSearch);
});
